
import BuilderInputs from 'components/builder/builder-inputs.vue'
import ResetModal from './reset-modal.vue'
import $profile from 'stores/profile.js'
import {makeProfileSchema} from '../settings-defs.js'

export default {
  components: {
    BuilderInputs,
    ResetModal
  },
  provide() {
    return {
      store: $profile,
    }
  },
  data() {
    return {
      schema: makeProfileSchema(),
      valid: true
    }
  },
  computed: {
    saving() {
      return $profile.saving
    },
    saved_at() {
      return $profile.saved_at
    }
  },
  methods: {
    async onUpdate() {
      if (this.valid) {
        await $profile.save()
      }

    },
    onReset(){
      this.$refs.reset.open()
    }
  }
}
